export default __webpack_public_path__ + "static/media/NOKO_1.85804e9d.gif";